module.exports = __webpack_public_path__ + "static/author-1-b8ce5a8fcaa0d39a5197da964079ba06.jpg";